import _implicitStylesheets from "./toastMessage.css";

import _implicitScopedStylesheets from "./toastMessage.scoped.css?scoped=true";

import {registerTemplate, sanitizeAttribute} from "lwc";
function tmpl($api, $cmp, $slotset, $ctx) {
  const {t: api_text, h: api_element, d: api_dynamic_text, b: api_bind} = $api;
  const {_m0, _m1, _m2} = $ctx;
  return [api_element("div", {
    classMap: {
      "toast-message_align": true
    },
    attrs: {
      "data-my-id": "toastMessageDiv"
    },
    key: 0
  }, [api_element("div", {
    classMap: {
      "slds-notify_container": true,
      "slds-is-relative": true,
      "toast-div_align": true
    },
    key: 1
  }, [api_element("div", {
    classMap: {
      "slds-notify": true,
      "slds-notify_toast": true,
      "slds-theme_success": true
    },
    attrs: {
      "role": "status"
    },
    key: 2
  }, [api_element("span", {
    classMap: {
      "slds-assistive-text": true
    },
    key: 3
  }, [api_text("success")]), api_element("span", {
    classMap: {
      "slds-icon_container": true,
      "slds-icon-utility-success": true,
      "slds-m-right_small": true,
      "slds-no-flex": true,
      "slds-align-top": true
    },
    attrs: {
      "title": "Deployment status"
    },
    key: 4
  }, [api_element("svg", {
    classMap: {
      "slds-icon": true,
      "slds-icon_small": true
    },
    attrs: {
      "aria-hidden": "true"
    },
    key: 5,
    svg: true
  }, [api_element("use", {
    attrs: {
      "xlink:href": sanitizeAttribute("use", "http://www.w3.org/2000/svg", "xlink:href", "/SLDS/icons/utility-sprite/svg/symbols.svg#success")
    },
    key: 6,
    svg: true
  }, [])])]), api_element("div", {
    classMap: {
      "slds-notify__content": true
    },
    key: 7
  }, [api_element("h2", {
    classMap: {
      "slds-text-heading_small": true
    },
    key: 8
  }, [api_text(api_dynamic_text($cmp.statusMessage))])]), api_element("div", {
    classMap: {
      "slds-notify__close": true
    },
    key: 9
  }, [api_element("button", {
    classMap: {
      "slds-button": true,
      "slds-button_icon": true,
      "slds-button_icon-inverse": true
    },
    attrs: {
      "title": "Close"
    },
    key: 10,
    on: {
      "click": _m0 || ($ctx._m0 = api_bind($cmp.closeToastMessage))
    }
  }, [api_element("svg", {
    classMap: {
      "slds-button__icon": true,
      "slds-button__icon_large": true
    },
    attrs: {
      "aria-hidden": "true"
    },
    key: 11,
    svg: true
  }, [api_element("use", {
    attrs: {
      "xlink:href": sanitizeAttribute("use", "http://www.w3.org/2000/svg", "xlink:href", "/SLDS/icons/utility-sprite/svg/symbols.svg#close")
    },
    key: 12,
    svg: true
  }, [])]), api_element("span", {
    classMap: {
      "slds-assistive-text": true
    },
    key: 13
  }, [api_text("Close")])])])])])]), api_element("div", {
    styleDecls: [["height", "0rem", false], ["display", "none", false]],
    attrs: {
      "data-my-id": "toastErrorMessageDiv"
    },
    key: 14
  }, [api_element("div", {
    classMap: {
      "slds-notify_container": true,
      "slds-is-relative": true,
      "toast-div_align": true
    },
    key: 15
  }, [api_element("div", {
    classMap: {
      "slds-notify": true,
      "slds-notify_toast": true,
      "slds-theme_error": true
    },
    attrs: {
      "role": "status"
    },
    key: 16
  }, [api_element("span", {
    classMap: {
      "slds-assistive-text": true
    },
    key: 17
  }, [api_text("error")]), api_element("span", {
    classMap: {
      "slds-icon_container": true,
      "slds-icon-utility-error": true,
      "slds-m-right_small": true,
      "slds-no-flex": true,
      "slds-align-top": true
    },
    key: 18
  }, [api_element("svg", {
    classMap: {
      "slds-icon": true,
      "slds-icon_small": true
    },
    attrs: {
      "aria-hidden": "true"
    },
    key: 19,
    svg: true
  }, [api_element("use", {
    attrs: {
      "xlink:href": sanitizeAttribute("use", "http://www.w3.org/2000/svg", "xlink:href", "/SLDS/icons/utility-sprite/svg/symbols.svg#error")
    },
    key: 20,
    svg: true
  }, [])])]), api_element("div", {
    classMap: {
      "slds-notify__content": true
    },
    key: 21
  }, [api_element("h2", {
    classMap: {
      "slds-text-heading_small": true
    },
    key: 22
  }, [api_text(api_dynamic_text($cmp.statusMessage)), api_element("a", {
    attrs: {
      "href": "#",
      "data-my-id": "moreInformation"
    },
    key: 23,
    on: {
      "click": _m1 || ($ctx._m1 = api_bind($cmp.showModalView))
    }
  }, [api_text("More information")])])]), api_element("div", {
    classMap: {
      "slds-notify__close": true
    },
    key: 24
  }, [api_element("button", {
    classMap: {
      "slds-button": true,
      "slds-button_icon": true,
      "slds-button_icon-inverse": true
    },
    attrs: {
      "title": "Close"
    },
    key: 25,
    on: {
      "click": _m2 || ($ctx._m2 = api_bind($cmp.closeToastErrorMessage))
    }
  }, [api_element("svg", {
    classMap: {
      "slds-button__icon": true,
      "slds-button__icon_large": true
    },
    attrs: {
      "aria-hidden": "true"
    },
    key: 26,
    svg: true
  }, [api_element("use", {
    attrs: {
      "xlink:href": sanitizeAttribute("use", "http://www.w3.org/2000/svg", "xlink:href", "/SLDS/icons/utility-sprite/svg/symbols.svg#close")
    },
    key: 27,
    svg: true
  }, [])]), api_element("span", {
    classMap: {
      "slds-assistive-text": true
    },
    key: 28
  }, [api_text("Close")])])])])])])];
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];


if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets)
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets)
}
tmpl.stylesheetToken = "my-toastMessage_toastMessage"
